import React, { memo } from 'react'
import { Grid } from '@mui/material'
import { Trans } from 'react-i18next'

import CustomDialog from '../shared/customDialog/CustomDialog'
import Input from '../shared/inputs/Input'
import { CURRENCIES } from '../../constants/app'
import {
  transWithArgs,
  validPointValueRule
} from '../../util/validation.helpers'
import { MAIN_PROFILE_DISPATCH } from '../../store/reducers/main'
import { formatTicks } from '../../util/string.helpers'
import { floorNumber, formatCurrencyValue } from '../../util/numbers.helpers'
import CustomAlert from '../shared/CustomAlert/CustomAlert'
import Text from '../shared/text/Text'

const DepositPopup = ({
  t,
  onClose,
  onSubmit,
  mainProfile: {
    amount,
    error,
    depositProcessing,
    preSaleDepositPrice,
    publicSaleDepositPrice
  },
  dispatchAction,
  saleEnded,
  walletBalance
}) => {
  return (
    <CustomDialog
      isForm
      title={`${t('home.deposit')} ${CURRENCIES.DEFAULT}`}
      description={t('home.deposit-desc')}
      open
      onClose={onClose}
      cancelProps={{ label: t('common.cancel'), autoWidth: true }}
      submitProps={{
        label: t('home.deposit'),
        disabled: depositProcessing || saleEnded,
        autoWidth: true
      }}
      body={
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Input
              label={t('home.deposit-amount')}
              value={amount}
              size='small'
              inputProps={{ maxLength: 32 }}
              onChange={(value) =>
                dispatchAction(MAIN_PROFILE_DISPATCH.AMOUNT, value)
              }
              bottomLabel={t('home.wallet-balance', {
                symbol: walletBalance?.symbol || CURRENCIES.DEFAULT,
                value: formatTicks(
                  formatCurrencyValue(walletBalance?.formatted) || 0
                )
              })}
              errorMessage={transWithArgs(
                t,
                error[MAIN_PROFILE_DISPATCH.AMOUNT]
              )}
              validate={[validPointValueRule]}
              startIcon={CURRENCIES.DEFAULT}
            />
            {amount && (
              <Text
                label={
                  <Trans
                    i18nKey='home.pre-pub-value'
                    values={{
                      preValue: formatTicks(
                        floorNumber(parseFloat(amount) / preSaleDepositPrice)
                      ),
                      pubValue: formatTicks(
                        floorNumber(parseFloat(amount) / publicSaleDepositPrice)
                      )
                    }}
                  />
                }
                sx={{ mt: 2 }}
              />
            )}
          </Grid>
          {(depositProcessing || saleEnded) && (
            <Grid item xs={12}>
              <CustomAlert
                info={t(
                  `home.${saleEnded ? 'sale-ended' : 'transaction-processing'}`
                )}
                onTimeOut={
                  depositProcessing
                    ? () => {
                        dispatchAction(
                          MAIN_PROFILE_DISPATCH.DEPOSIT_PROCESSING,
                          false
                        )
                      }
                    : null
                }
              />
            </Grid>
          )}
        </Grid>
      }
      onSubmit={onSubmit}
      t={t}
    />
  )
}

export default memo(DepositPopup)
